import { RootState } from 'redux-store/store'

export const rolesSelector = (state: RootState) => state.roles

export const isSuperViewerSelector = (state: RootState) =>
  state.roles.isSuperViewer

export const isViewingAsAdminSelector = (state: RootState) =>
  state.roles.isViewingAsAdmin
